import React from 'react'
import { Widget } from '@typeform/embed-react'

const ContactBlock = () => (
    <div id="contact-us" className="relative container-entry">
    {/* <iframe title="Zadro Contact us" src="https://form.typeform.com/to/bJLUDhW2?typeform-embed-id=044491735905780594&amp;typeform-embed=embed-widget&amp;typeform-source=localhost&amp;typeform-medium=embed-sdk&amp;typeform-medium-version=next" data-testid="iframe" allow="microphone; camera" style={{ width: "100%",  height: "580px", border: '0px', transform: 'translateZ(0px)' }}></iframe> */}
    </div>
  )

export default ContactBlock